import { appEvents, type CompanionDockAutoOpenReason } from "@/shared/lib/events";

/** Publish a one-shot request asking the companion dock to auto-open. Shared by
 *  the ads-workspace slices (job dispatch, chat-image attach, sub-agent input,
 *  Scout research run) so they don't have to import from the store composer —
 *  importing the composer back into a slice would create a circular dependency. */
export function requestCompanionDockAutoOpen(reason: CompanionDockAutoOpenReason): void {
  appEvents.publish({ type: "companion:dock-auto-open", reason });
}
